import React from 'react';
import { ScrollVideo } from './ScrollVideo';
import { SectionOne } from './SectionOne';
import { SectionTwo } from './SectionTwo';
export function NovaSection() {
  return <div id="nova-container" className="relative font-sans text-white nova-selection bg-black" data-id="element-1707">
      {/* Sticky container for the video background */}
      <div className="sticky top-0 h-screen w-full overflow-hidden" data-id="element-1708">
        <ScrollVideo containerId="nova-container" data-id="element-1709" />
      </div>

      {/* Content overlays the sticky video */}
      <div className="relative z-10 -mt-[100vh]" data-id="element-1710">
        <SectionOne data-id="element-1711" />
        <div aria-hidden className="h-[80vh]" data-id="element-1712" />
        <SectionTwo data-id="element-1713" />
      </div>
    </div>;
}